import { useNavigate } from 'react-router-dom'
import { ShieldAlert } from 'lucide-react'
import { useQueryClient } from '@tanstack/react-query'
import { useAuthStore } from '@/stores/authStore'

/**
 * Fixed red banner shown throughout an impersonated session.
 *
 * Non-negotiable: someone acting inside a customer's workspace must never be
 * able to forget they are doing so. It is also what makes read-only
 * impersonation understandable rather than confusing when a save fails.
 */
export function ImpersonationBanner() {
  const isImpersonating = useAuthStore((s) => s.isImpersonating)
  const tenant = useAuthStore((s) => s.session?.tenant)
  const clear = useAuthStore((s) => s.clear)
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  if (!isImpersonating) return null

  return (
    <div className="flex items-center gap-3 bg-critical px-6 py-2 text-sm text-white">
      <ShieldAlert className="h-4 w-4 shrink-0" strokeWidth={2} aria-hidden />
      <p className="min-w-0 flex-1">
        <span className="font-semibold">Support session.</span> You are viewing{' '}
        <span className="font-semibold">{tenant?.name}</span> as their owner. This is logged.
      </p>
      <button
        type="button"
        onClick={() => {
          clear()
          queryClient.clear()
          navigate('/login', { replace: true })
        }}
        className="shrink-0 rounded-md bg-white/15 px-3 py-1 font-medium transition-colors hover:bg-white/25"
      >
        Exit
      </button>
    </div>
  )
}
